/* eslint-disable */
(async function bootstrapCredibill () {

  function loadClassicScript (src) {
    return new Promise(function (resolve, reject) {
      var existing = window.document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
          return;
        }

        existing.addEventListener('load', function () {
          existing.dataset.loaded = 'true';
          resolve();
        }, {once : true});
        existing.addEventListener('error', reject, {once : true});
        return;
      }

      var script = window.document.createElement('script');
      script.src = src;
      script.async = false;
      script.addEventListener('load', function () {
        script.dataset.loaded = 'true';
        resolve();
      }, {once : true});
      script.addEventListener('error', reject, {once : true});
      window.document.head.appendChild(script);
    });
  }


  const baseModules = await Promise.all([
    import('jquery'),
    import('lodash'),
    import('moment')
  ]);
  const jqueryModule = baseModules[0];
  const lodashModule = baseModules[1];
  const momentModule = baseModules[2];
  window.$ = window.jQuery = jqueryModule.default || jqueryModule;
  window._ = lodashModule.default || lodashModule;
  window.moment = momentModule.default || momentModule;

  const angularModule = await import('angular');
  window.angular = angularModule.default || angularModule;

  await import('/build/vite/vendor.generated.js');
  var bootboxScript = loadClassicScript('/assets/vendor/bootbox.js');
  var notifyScript = loadClassicScript('/assets/vendor/bootstrap-notify.js');
  var aosScript = loadClassicScript('/assets/aos/aos.js');
  await bootboxScript;
  await loadClassicScript('/assets/vendor/ngBootbox.js');
  await Promise.all([notifyScript, aosScript]);

  await import('/build/vite/app.generated.js');

  var hasInitializedAOS = false;

  function initializeAOS () {
    var init;

    function attachAngularHooks (retries) {
      var injector;
      var rootScope;

      if (!window.angular || !window.angular.element) {
        return;
      }

      injector = window.angular.element(window.document).injector();
      if (!injector) {
        if (retries > 0) {
          setTimeout(function () {
            attachAngularHooks(retries - 1);
          }, 100);
        }
        return;
      }

      rootScope = injector.get('$rootScope');
      rootScope.$on('$viewContentLoaded', function () {
        setTimeout(init, 0);
      });
      rootScope.$on('$stateChangeSuccess', function () {
        setTimeout(init, 0);
      });
      setTimeout(init, 0);
    }

    if (hasInitializedAOS || !window.AOS) {
      return;
    }

    hasInitializedAOS = true;

    init = function () {
      if (window.AOS && typeof window.AOS.refreshHard === 'function') {
        window.AOS.refreshHard();
      } else if (window.AOS && typeof window.AOS.refresh === 'function') {
        window.AOS.refresh();
      }
    };

    window.AOS.init();

    if (window.document.readyState === 'loading') {
      window.document.addEventListener('DOMContentLoaded', init, {once : true});
    } else {
      setTimeout(init, 0);
    }

    window.addEventListener('load', init, {once : true});

    attachAngularHooks(30);
  }

  if (window.angular) {
    window.angular.element(function () {
      window.angular.bootstrap(window.document, ['Credibill']);
      initializeAOS();
    });
  } else {
    initializeAOS();
  }
}().catch(function (error) {
  console.error('[vite-bootstrap] Failed to initialize Credibill', error);
}));
